import './machineConfig.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { setEnvironment } from '@vse/environment';
import { standalone } from '@vse/main';
import { RunningApplicationWarning } from './RunningApplicationWarning';
import { CYPRESS_DATA_ATTRIBUTE_NAME, CypressDataAttributes } from '@cypress/data-attributes';

/**
 * @param {Library} library The MachineLogic Library.
 * @param {Navigate} navigate A function to navigate to another page.
 * @returns {(() => void) | undefined} A cleanup function, if need be.
 */
export function initializeMachineConfig (library, navigate) {
  setEnvironment('pendant', 'configuration');

  const machineConfigContainer = $('<div>')
    .attr('id', 'main')
    .addClass('v_layout machine_config_page')
    .attr(CYPRESS_DATA_ATTRIBUTE_NAME, CypressDataAttributes.MACHINE_CONFIG_PAGE);

  const tabsContainer = $("<div id='tab_pane' class='h_layout'>");
  const tabContent = $("<div id='content_main' class='h_layout spaced'>");
  const leftPane = $("<div id='left_pane' class='v_layout'>");
  const rightPane = $("<div id='right_pane' class='v_layout'>");

  $('#guiContainer')
    .addClass('v_layout spaced')
    .append(
      machineConfigContainer.append(
        tabsContainer,
        tabContent.append(
          leftPane,
          rightPane,
        ),
      ),
    );

  standalone(library, navigate, { renderUi: true, leftPane, rightPane });

  const currentlyRunningApplication = library.getCurrentApplication();

  return disableMachineConfigWhileApplicationIsRunning(currentlyRunningApplication, machineConfigContainer);
}

/**
 * Disables the machine config screen while an application is running.
 * It wil be re-enabled when the application is stopped.
 *
 * @param {import("@vse/machinelogic/ApplicationBase").ApplicationBase | undefined} currentlyRunningApplication
 * @param {JQuery} machineConfigContainer
 * @return {(() => void) | undefined} A cleanup function.
 */
function disableMachineConfigWhileApplicationIsRunning (currentlyRunningApplication, machineConfigContainer) {
  if (!currentlyRunningApplication?.isRunning()) {
    return;
  }

  machineConfigContainer.addClass('disabled');

  const runningApplicationWarning = $('<div>')
    .attr('id', 'running_application_warning')
    .attr(CYPRESS_DATA_ATTRIBUTE_NAME, CypressDataAttributes.MACHINE_CONFIG_PAGE_RUNNING_APPLICATION_WARNING)
    .appendTo($('#guiContainer'));

  ReactDOM.render(<RunningApplicationWarning />, runningApplicationWarning[0]);

  const applicationStateListener = {
    onStateChanged: () => {
      if (!currentlyRunningApplication.isRunning()) {
        machineConfigContainer.removeClass('disabled');
        runningApplicationWarning.remove();
      }
    },
  };

  currentlyRunningApplication.addListener(applicationStateListener);

  return () => {
    currentlyRunningApplication.removeListener(applicationStateListener);
  };
}
